/**
 * MODULE: _shared/frontend-shell/src/api/assistantApi.ts
 * PURPOSE: HTTP helpers for assistant endpoints (approve destructive platform tools).
 *
 * DEPENDENCIES: axios, _shared/lib/frontend/api/config (API_CONFIG, getAuthHeaders)
 * PUBLIC API: approveToolCall, ApproveToolCallResult
 * SIDE EFFECTS: POST to API gateway
 * AGENT SAFETY: SAFE
 * FILE SIZE: 34 / 200 lines
 * RECENT: 2026-04-19 [2.2.543] **`ApproveToolCallResult`** (**`message`**, **`success`**) from **`POST …/threads/{id}/approve`** — root **`CHANGELOG` [2.2.543]**.
 */

import axios from 'axios';
import { API_CONFIG, getAuthHeaders } from '../../../lib/frontend/api/config';

export type ApproveToolCallResult = {
  success: boolean;
  approved?: boolean;
  message?: string;
};

export async function approveToolCall(
  threadId: string,
  approved: boolean,
  toolName: string,
  toolArgs: Record<string, unknown>
): Promise<ApproveToolCallResult> {
  const { data } = await axios.post<ApproveToolCallResult>(
    `${API_CONFIG.baseURL}/api/v1/assistant/threads/${encodeURIComponent(threadId)}/approve`,
    { approved, tool_name: toolName, tool_args: toolArgs },
    { headers: getAuthHeaders(), timeout: 60000 }
  );
  return data ?? { success: true, approved: approved };
}
